'use client';
import { XYChartLineSparkEndpoint } from './XYChartLineSparkEndpoint';
import type { XYChartSparkPoint } from './xychart-sparkline-model';
export interface XYChartLineSparkProps {
    focusAreaPath: string;
    focusLinePath: string;
    focusGradientId: string;
    lineGradientId: string;
    lastPoint: XYChartSparkPoint | undefined;
    latestPointIdentity: string;
    height: number;
    trendColor: string;
}
export function XYChartLineSpark({ focusAreaPath, focusLinePath, focusGradientId, lineGradientId, lastPoint, latestPointIdentity, height, trendColor, }: XYChartLineSparkProps) {
    return (
      <>
        {focusAreaPath && (<path d={focusAreaPath} fill={`url(#${focusGradientId})`}/>)}

        {focusLinePath && (<path d={focusLinePath} fill="none" stroke={`url(#${lineGradientId})`} strokeWidth={3.5} strokeLinecap="round" strokeLinejoin="round"/>)}

        {lastPoint && (<XYChartLineSparkEndpoint point={lastPoint} height={height} trendColor={trendColor}/>)}
      </>
    );
}
